export default __webpack_public_path__ + "static/index-sample-01-d48d2e2de779da7554df3cb70f5ef8ed.jpg";